<template>
  <div class="vhp-tabs-container">
    <div class="vhp-tabs" data-aos-duration="800" data-aos="fade">
      <div class="tabs-background"></div>
      <div class="wrap" :class="'grid-' + items.length">
        <button
          v-for="(item, index) in items"
          :key="index"
          class="tab-btn"
          :class="{ active: index === tabIndex }"
          @click.stop="(tabIndex = index), (itemIndex = 0), $emit('click', index)"
        >
          <div class="vhp-text small bold">
            {{ item.title }}
          </div>
        </button>
      </div>
    </div>

 

    <div
      data-aos-duration="800" data-aos="fade"
      class="vhp-tabs-contents"
    >
      <slot v-bind:index="tabIndex">
      </slot>
    </div>
  </div>
</template>

<script>

export default {
  name: "vhpTabs",
  directives: {
  },
  props: {
    items: Array
  },
  data() {
    return {
      tabIndex: 0
    };
  },


  methods: {
    
  },
};
</script>


<style lang="scss" src="./vhpTabs.scss"></style>